import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SuccessIcon from '../../images/icon-success.inline.svg';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
`;

const Icon = styled(SuccessIcon)`
  margin-bottom: 16px;
`;

const Text = styled.div`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  text-align: center;
  color: #354354;
`;

class Success extends Component {
  render() {
    const { message } = this.props;

    return (
      <Container>
        <Icon
          width="56"
          height="56"
          viewBox="0 0 56 56"
        />
        <Text>{message}</Text>
      </Container>
    );
  }
}

Success.propTypes = {
  message: PropTypes.string,
};

Success.defaultProps = {
  message: 'Message text',
};

export { Success };
